module.exports = __webpack_public_path__ + "static/orange_sticky_tab-68b2f2851957372af7198c2eca18d647.png";